import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage, intlShape } from 'react-intl'
import * as shapes from '../../constant/shapes'

import * as selectors from './trackListSelectors'
import * as playerSelectors from '../miniPlayer/miniPlayerSelectors'

import TrackItem from './TrackItem'
import { ORIGIN_PLAYQUEUE_TYPES } from '../miniPlayer/AudioPlayer/playerConstants'
import appConst from '../../constant/appConst'

class TrackList extends PureComponent {

	render() {
		const {
			fields,
			discList,
			listContainerClassName,
			listClassName,
			moreItemsCallback,
			offset,
			total,
			mediaCount,
			playing,
			isCurrentTrack
		} = this.props
		const { intl } = this.context

		if (total === 0) {
			return(
				<div className="empty-state">
					<p>{intl.formatMessage({ id: 'tracklist.noTracks' })}</p>
				</div>
			)
		}

		return (
			<div>
				{discList.map((disc, keyDisc) => (
					<div className={listContainerClassName} key={`tracks-list-${keyDisc}`}>
						{mediaCount > 1 && (
							<FormattedMessage className="label1" id="tracklist.media_count" values={{ mediaNumber: keyDisc }} />
						)}
						<ul className={listClassName}>
							<li className="c3">
								{fields.map((field, key) => (
									<span className={`track-${field.type}`} key={`table-header-${key}`}>
										{field.type !== 'cover' &&
											intl.formatMessage({ id: `tracklist.header.${field.type}` }) ||
											' '
										}
									</span>
								))}
							</li>
							{disc.map((track, trackKey) => (
								<li
									key={`table-row-${trackKey}`}
									{ ...(isCurrentTrack(ORIGIN_PLAYQUEUE_TYPES.track, track.id) && { className: `isPlaying ${!playing && 'isPause'}` }) }
									style={{ height: '40px' }}
								>
									<TrackItem track={track} fields={fields} />
								</li>
							))}
						</ul>
					</div>
				))}
				{moreItemsCallback && offset + appConst.trackListLoadStep < total &&
				<div className="text-center mb20">
					<span onClick={moreItemsCallback} className="bt7">{intl.formatMessage({ id: 'buttons.showmore' })}</span>
				</div>}
			</div>
		)
	}
}

TrackList.propTypes = {
	discList: PropTypes.arrayOf(PropTypes.arrayOf(shapes.trackItem)),
	fields: PropTypes.arrayOf(PropTypes.shape({
		type: PropTypes.string,
		render: PropTypes.func
	})).isRequired,
	listContainerClassName: PropTypes.string,
	listClassName: PropTypes.string,
	moreItemsCallback: PropTypes.func,
	offset: PropTypes.number,
	total: PropTypes.number,
	mediaCount: PropTypes.number,
	idPlaying: PropTypes.number,
	playing: PropTypes.bool,
	isCurrentTrack: PropTypes.func
}

TrackList.contextTypes = {
	intl: intlShape
}

const mapStateToProps = state => ({
	discList: selectors.getTrackListItemsByMediaNumber(state),
	offset: selectors.getTrackListOffset(state),
	total: selectors.getTrackListTotal(state),
	mediaCount: selectors.getMediaCount(state),
	idPlaying: (playerSelectors.getIdCurrentTrack(state)),
	playing: playerSelectors.isPlaying(state),
	isCurrentTrack: (type, idElement) => playerSelectors.isCurrentTrack(state)(type, idElement)
})

export default connect(mapStateToProps)(TrackList)



// WEBPACK FOOTER //
// ./src/components/tracklist/TrackList.jsx